import { render } from "./ConceptosView.vue?vue&type=template&id=a759a288"
import script from "./ConceptosView.vue?vue&type=script&lang=js"
export * from "./ConceptosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__